import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import config from "../../../../../config";
import { EquipmentContext } from "../../useContext/context";

const PAYCHEX_ORG_ID = config.paymentcloud.PAYCHEX_ORG_ID;
const EMS_ORG_ID = config.paymentcloud.EMS_ORG_ID;

export default function AddonSelect({ addon_list, handleOnChange, id, selectedAddons = [] }) {
    const [options, setOptions] = useState([]);
    const { org_id } = useContext(EquipmentContext);
    const [addons, setAddons] = useState(selectedAddons);

    useEffect(() => {
        if (Array.isArray(addon_list)) {
            const list_options = addon_list.map((item) => ({
                value: item.id,
                label: item.equipment_name,
            }));
            setOptions(list_options);
        }
    }, [addon_list]);

    return (
        <>
            <div className="input-wrapper">
                <label htmlFor={"colors"}>{ (id == 19 && (org_id == PAYCHEX_ORG_ID || org_id == EMS_ORG_ID)) ? "Select Package" : "Select Add-ons"}</label>
                <Select
                    isMulti
                    name="colors"
                    options={options}
                    value={addons}
                    className="react-select"
                    classNamePrefix="select"
                    styles={{
                        menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                        }),
                    }}
                    onChange={(addons) => {
                        setAddons(addons);
                        if (typeof handleOnChange == "function") {
                            handleOnChange(addons);
                        }
                    }}
                />
            </div>
        </>
    );
}
